<template>
  <div class="main">
    <Header
      :show="true"
      title="运营报告"
      left=""
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-cell
        :value="listQuery.type.name"
        is-link
        @click="listQuery.type.show = true"
      >
        <template #title>
          <span style="font-size: 2vh">报告类型</span>
        </template>
      </van-cell>
      <van-action-sheet
        v-model="listQuery.type.show"
        :actions="listQuery.type.actions"
        cancel-text="取消"
        description="请选择待查询的报告类型"
        @select="onSelectTypeChoose"
      />
      <van-cell
        :value="listQuery.date.value"
        is-link
        @click="listQuery.date.show = true"
      >
        <template #title>
          <span style="font-size: 2vh">选择日期</span>
        </template>
      </van-cell>
      <van-calendar
        v-model="listQuery.date.show"
        :min-date="listQuery.date.min"
        :max-date="listQuery.date.max"
        :show-confirm="false"
        @confirm="onConfirmDateChoose"
      />
      <div style="margin: 16px">
        <van-button
          round
          block
          type="info"
          @click="handleClickQuery"
        >
          查询
        </van-button>
      </div>
      <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
      <van-cell-group title="访客统计">
        <van-cell title="预约人次">
          <template #default>
            <span class="custom-title">{{ visitor.orderCount }}次</span>
          </template>
        </van-cell>
        <van-cell title="实际到访人次">
          <template #default>
            <span class="custom-title">{{ visitor.accessCount }}次</span>
          </template>
        </van-cell>
        <!-- <van-cell title="办公区预约人次" >
            <template #default>
              <span class="custom-title">{{ data.visitor.detail[0].order }}次</span>
            </template>
          </van-cell>
          <van-cell title="办公区实际访问人次" >
            <template #default>
              <span class="custom-title">{{ data.visitor.detail[0].reality }}次</span>
            </template>
          </van-cell>
          <van-cell title="生产区预约人次" >
            <template #default>
              <span class="custom-title">{{ data.visitor.detail[1].order }}次</span>
            </template>
          </van-cell>
          <van-cell title="生产区实际访问人次" >
            <template #default>
              <span class="custom-title">{{ data.visitor.detail[1].reality }}次</span>
            </template>
          </van-cell> -->
      </van-cell-group>
      <!-- <van-cell-group title="车辆访问统计">
          <van-cell title="预约车数" >
            <template #default>
              <span class="custom-title">{{ data.truck.order }}次</span>
            </template>
          </van-cell>
          <van-cell title="实际到访车次" >
            <template #default>
              <span class="custom-title">{{ data.truck.reality }}次</span>
            </template>
          </van-cell>
        </van-cell-group> -->
      <van-cell-group title="原料统计">
        <van-cell title="预约车数">
          <template #default>
            <span class="custom-title">{{ crude.orderCount }}次</span>
          </template>
        </van-cell>
        <van-cell title="到访车次">
          <template #default>
            <span class="custom-title">{{ crude.accessCount }}次</span>
          </template>
        </van-cell>
        <div
          v-for="(item, index) in supplier"
          :key="index"
        >
          <van-cell
            :title="item.name"
            style="background-color: #f8f8f8; color: #969799"
          >
            <template #default>
              <span
                class="custom-title"
              >{{ item.totalCount }}车/{{ item.totalWeight }}吨</span>
            </template>
          </van-cell>
          <div
            v-for="(listItem, listIndex) in item.list"
            :key="listIndex"
          >
            <van-cell
              :title="listItem.gys"
            >
              <template #default>
                <span
                  class="custom-title"
                >{{ listItem.count }}车/{{ listItem.weight }}吨</span>
              </template>
            </van-cell>
          </div>
        </div>

        <!-- <van-cell title="1-2碎石">
          <template #default>
            <span class="custom-title"
              >{{ data.concrete.total }}车/{{ data.concrete.total }}吨</span
            >
          </template>
        </van-cell>
        <van-cell title="├  供应商1">
          <template #default>
            <span class="custom-title"
              >{{ data.concrete.total }}车/{{ data.concrete.total }}吨</span
            >
          </template>
        </van-cell>
        <van-cell title="└  供应商2">
          <template #default>
            <span class="custom-title"
              >{{ data.concrete.total }}车/{{ data.concrete.total }}吨</span
            >
          </template>
        </van-cell>
        <van-cell title="1-3碎石">
          <template #default>
            <span class="custom-title"
              >{{ data.concrete.total }}车/{{ data.concrete.total }}吨</span
            >
          </template>
        </van-cell>
        <van-cell title="├  供应商3">
          <template #default>
            <span class="custom-title"
              >{{ data.concrete.total }}车/{{ data.concrete.total }}吨</span
            >
          </template>
        </van-cell>
        <van-cell title="└  供应商4">
          <template #default>
            <span class="custom-title"
              >{{ data.concrete.total }}车/{{ data.concrete.total }}吨</span
            >
          </template>
        </van-cell>
        <van-cell title="矿粉">
          <template #default>
            <span class="custom-title"
              >{{ data.concrete.total }}车/{{ data.concrete.total }}吨</span
            >
          </template>
        </van-cell>
        <van-cell title="└  供应商5">
          <template #default>
            <span class="custom-title"
              >{{ data.concrete.total }}车/{{ data.concrete.total }}吨</span
            >
          </template>
        </van-cell>
        <van-cell
          v-for="item in data.concrete.detail"
          :key="item.name"
          :title="item.name"
        >
          <template #default>
            <span class="custom-title"
              >{{ item.count }}车 / {{ item.weight }}吨</span
            >
          </template>
        </van-cell> -->
      </van-cell-group>
      <!-- <van-cell-group title="罐装货车统计">
        <van-cell title="预约车数">
          <template #default>
            <span class="custom-title">{{ data.tank.order }}次</span>
          </template>
        </van-cell>
        <van-cell title="实际到访车次">
          <template #default>
            <span class="custom-title">{{ data.tank.reality }}次</span>
          </template>
        </van-cell>
        <van-cell title="累计过磅实重">
          <template #default>
            <span class="custom-title">{{ data.tank.total }}吨</span>
          </template>
        </van-cell>
        <van-cell
          v-for="item in data.tank.detail"
          :key="item.name"
          :title="item.name"
        >
          <template #default>
            <span class="custom-title"
              >{{ item.count }}车 / {{ item.weight }}吨</span
            >
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group title="骨料货车统计">
        <van-cell title="预约车数">
          <template #default>
            <span class="custom-title">{{ data.aggregate.order }}次</span>
          </template>
        </van-cell>
        <van-cell title="实际到访车次">
          <template #default>
            <span class="custom-title">{{ data.aggregate.reality }}次</span>
          </template>
        </van-cell>
        <van-cell title="累计过磅实重">
          <template #default>
            <span class="custom-title">{{ data.aggregate.total }}吨</span>
          </template>
        </van-cell>
        <van-cell
          v-for="item in data.aggregate.detail"
          :key="item.name"
          :title="item.name"
        >
          <template #default>
            <span class="custom-title"
              >{{ item.count }}车 / {{ item.weight }}吨</span
            >
          </template>
        </van-cell>
      </van-cell-group> -->

      <!-- <van-cell-group title="故障统计">
          <van-cell title="人脸识别系统" >
            <template #default>
              <span class="custom-title">{{ data.fault.face }}次</span>
            </template>
          </van-cell>
          <van-cell title="车牌识别系统" >
            <template #default>
              <span class="custom-title">{{ data.fault.gate }}次</span>
            </template>
          </van-cell>
          <van-cell title="无人地磅系统" >
            <template #default>
              <span class="custom-title">{{ data.fault.weight }}次</span>
            </template>
          </van-cell>
          <van-cell title="自助灌料系统" >
            <template #default>
              <span class="custom-title">{{ data.fault.jar }}次</span>
            </template>
          </van-cell>
          <van-cell title="网络状态" >
            <template #default>
              <span class="custom-title">{{ data.fault.net }}次</span>
            </template>
          </van-cell>
          <van-cell title="其他" >
            <template #default>
              <span class="custom-title">{{ data.fault.other }}次</span>
            </template>
          </van-cell>
        </van-cell-group> -->
      <!-- </van-pull-refresh> -->
      <div style="height: 3.8rem; background-color: #f8f8f8" />
    </div>
    <Footer value="report" />
  </div>
</template>

<script>
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import checkPermission from "@/utils/permission";
import { parseTime } from "@/utils";
import { showPhoneAlarm } from "@/global/function.js";
import {
  getDayReport,
  getMonthReport,
  getYearReport,
  getEquipmentList,
  getDayNdReport,
  getMonthNdReport,
  getYearNdReport,
  getNdReport
} from "@/api/report.js";

export default {
  name: "Report",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      listQuery: {
        date: {
          show: false,
          min: new Date(2020, 1, 1),
          max: new Date(2030, 12, 31),
          value: parseTime(new Date(), "{y}/{m}/{d}"),
        },
        type: {
          show: false,
          actions: [
            { name: "日报", subname: "" },
            { name: "月报" },
            { name: "年报" },
          ],
          name: "日报",
        },
        day: new Date().getTime(),
        month: new Date().getTime(),
        year: new Date().getFullYear(),
      },
      isLoading: false,
      data: {
        visitor: {
          order: 0,
          reality: 0,
          detail: [
            {
              name: "办公区",
              order: 0,
              reality: 0,
            },
            {
              name: "生产区",
              order: 0,
              reality: 0,
            },
          ],
        },
        truck: {
          order: 0,
          reality: 0,
        },
        concrete: {
          order: 0,
          reality: 0,
          total: 0,
          detail: [],
        },
        tank: {
          order: 0,
          reality: 0,
          total: 0,
          detail: [],
        },
        aggregate: {
          order: 0,
          reality: 0,
          total: 0,
          detail: [],
        },
        fault: {
          face: 0,
          gate: 0,
          weight: 0,
          jar: 0,
          net: 0,
          other: 0,
        },
      },

      //////////////////////////////////
      // 访客统计
      visitor: {
        orderCount: 0,
        accessCount: 0,
      },
      // 原料统计
      crude: {
        orderCount: 0,
        accessCount: 0,
      },

      // 供应商统计
      supplier: [],

      //////////////////////////////////
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    this.handledefault();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      // this.$router.go(-1)
      console.log("report-left");
    },
    handleClickRight() {
      console.log("report-right");
    },
    formatDate(date) {
      this.listQuery.day = date.getTime();
      this.listQuery.month = date.getTime();
      this.listQuery.year = date.getFullYear();

      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      return `${year}/${month + 1 > 9 ? month + 1 : "0" + (month + 1)}/${
        day > 9 ? day : "0" + day
      }`;
    },
    onConfirmDateChoose(date) {
      this.listQuery.date.show = false;
      this.listQuery.date.value = this.formatDate(date);
    },
    onSelectTypeChoose(item) {
      this.listQuery.type.show = false;
      this.listQuery.type.name = item.name;
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.handleClickQuery();
        showPhoneAlarm(true, "toast", null, 2000, null, "刷新数据", "刷新完成");
      }, 1000);
    },
    handledefault() {
      const that = this
      getDayNdReport().then((res) => {
            const { data } = res;
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "",
                data.message
              )
            ) {
              that.responseHandle(data.data);
            }
          });
    },
    handleClickQuery() {
      // if (this.listQuery.type.name === '日报') {
      //   this.handleGetDayReport()
      // } else if (this.listQuery.type.name === '月报') {
      //   this.handleGetMonthReport()
      // } else if (this.listQuery.type.name === '年报') {
      //   this.handleGetYearReport()
      // }
      const that = this;
      const param = {
        date: this.listQuery.day,
      };
      switch (this.listQuery.type.name) {
        case "月报":
          param.date = this.listQuery.month;
          getMonthNdReport(param).then((res) => {
            const { data } = res;
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "",
                data.message
              )
            ) {
              that.responseHandle(data.data);
            }
          });
          break;
        case "年报":
          param.date = this.listQuery.year;
          getYearNdReport(param).then((res) => {
            const { data } = res;
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "",
                data.message
              )
            ) {
              that.responseHandle(data.data);
            }
          });
          break;
        default:
          param.date = this.listQuery.day;
          getNdReport(param).then((res) => {
            const { data } = res;
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "",
                data.message
              )
            ) {
              that.responseHandle(data.data);
            }
          });
          break;
      }
    },

    // 请求数据处理
    responseHandle(data) {
      // console.log(data)
      // 访客统计处理
      this.visitor = data.person;
      // 原料统计处理
      this.crude.accessCount = 0;
      this.crude.orderCount = 0;
      for (var i = 0, len = data.car.length; i < len; i++) {
        this.crude.accessCount = this.add(
          this.crude.accessCount,
          data.car[i].accessCount
        );
        this.crude.orderCount = this.add(
          this.crude.orderCount,
          data.car[i].orderCount
        );
      }
      // 供应商统计处理
      var nameArr = [];
      var item = {};
      this.supplier = [];
      for (var j = 0, jlen = data.order.length; j < jlen; j++) {
        item = data.order[j];
        // console.log(item)
        if (!item.gys || !item.name) {
          continue;
        }
        // 取name分组的索引
        var index = nameArr.indexOf(item.name);
        // 没有name索引时，初始化分组信息
        if (index === -1) {
          // 加入数组
          nameArr.push(item.name);
          // 初始化
          this.supplier.push({
            name: item.name,
            totalCount: item.count,
            totalWeight: item.weight,
            list: [item],
          });
        } else {
          // 分组赋值求和
          this.supplier[index].totalCount = this.add(
            this.supplier[index].totalCount,
            item.count
          );
          this.supplier[index].totalWeight = this.add(
            this.supplier[index].totalWeight,
            item.weight
          );
          this.supplier[index].list.push(item);
        }
        
      }
      // console.log(this.supplier, this.crude, this.visitor)
    },
    add(num1, num2) {
      var p1 = 0;
      var p2 = 0;

      if (num1.toString().split(".").length > 1) {
        p1 = num1.toString().split(".")[1].length;
      }

      if (num2.toString().split(".").length > 1) {
        p2 = num2.toString().split(".")[1].length;
      }

      var p = p1 > p2 ? p1 : p2;

      var n1 = num1 * Math.pow(10, p);
      var n2 = num2 * Math.pow(10, p);

      var result = (n1 + n2) / Math.pow(10, p);

      return result.toFixed(2);
    },

    // handleGetDayReport() {

    //   getDayReport(data).then(response => {

    //       const items = data.data
    //       for (let i=0; i<items.length; i++) {
    //         let totalWeight = 0
    //         switch(items[i].type) {
    //           case 1:
    //             this.data.visitor.order = items[i].orderCount
    //             this.data.visitor.reality = items[i].accessCount
    //           break;
    //           case 2:
    //             this.data.concrete.order = items[i].orderCount
    //             this.data.concrete.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.concrete.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.concrete.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.concrete.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           case 3:
    //             this.data.aggregate.order = items[i].orderCount
    //             this.data.aggregate.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.aggregate.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.aggregate.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.aggregate.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           case 4:
    //             this.data.tank.order = items[i].orderCount
    //             this.data.tank.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.tank.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.tank.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.tank.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           default:
    //           break;
    //         }
    //       }
    //     }
    //   }).catch(function(error) {
    //     console.error(error)
    //   })
    // },
    // handleGetMonthReport() {
    //   const data = {
    //     date: this.listQuery.month
    //   }
    //   getMonthNdReport(data).then(res => {
    //     console.log(res)
    //   })
    //   getMonthReport(data).then(response => {
    //     const { data } = response
    //     if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '', data.message)) {
    //       const items = data.data
    //       for (let i=0; i<items.length; i++) {
    //         let totalWeight = 0
    //         switch(items[i].type) {
    //           case 1:
    //             this.data.visitor.order = items[i].orderCount
    //             this.data.visitor.reality = items[i].accessCount
    //           break;
    //           case 2:
    //             this.data.concrete.order = items[i].orderCount
    //             this.data.concrete.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.concrete.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.concrete.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.concrete.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           case 3:
    //             this.data.aggregate.order = items[i].orderCount
    //             this.data.aggregate.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.aggregate.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.aggregate.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.aggregate.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           case 4:
    //             this.data.tank.order = items[i].orderCount
    //             this.data.tank.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.tank.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.tank.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.tank.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           default:
    //           break;
    //         }
    //       }
    //     }
    //   }).catch(function(error) {
    //     console.error(error)
    //   })
    // },
    // handleGetYearReport() {
    //   const data = {
    //     date: this.listQuery.year
    //   }

    //   getYearReport(data).then(response => {
    //     const { data } = response
    //     if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '', data.message)) {
    //       const items = data.data
    //       for (let i=0; i<items.length; i++) {
    //         let totalWeight = 0
    //         switch(items[i].type) {
    //           case 1:
    //             this.data.visitor.order = items[i].orderCount
    //             this.data.visitor.reality = items[i].accessCount
    //           break;
    //           case 2:
    //             this.data.concrete.order = items[i].orderCount
    //             this.data.concrete.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.concrete.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.concrete.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.concrete.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           case 3:
    //             this.data.aggregate.order = items[i].orderCount
    //             this.data.aggregate.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.aggregate.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.aggregate.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.aggregate.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           case 4:
    //             this.data.tank.order = items[i].orderCount
    //             this.data.tank.reality = items[i].accessCount
    //             totalWeight = 0
    //             this.data.tank.detail = []
    //             for (let j=0; j<items[i].truckLoadList.length; j++) {
    //               totalWeight += items[i].truckLoadList[j].weight
    //               this.data.tank.detail.push({
    //                 name: items[i].truckLoadList[j].name,
    //                 weight: items[i].truckLoadList[j].weight,
    //                 count: items[i].truckLoadList[j].count
    //               })
    //             }
    //             this.data.tank.total = parseFloat(totalWeight).toFixed(2)
    //           break;
    //           default:
    //           break;
    //         }
    //       }
    //     }
    //   }).catch(function(error) {
    //     console.error(error)
    //   })
    // }
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
.van-cell {
  padding: 2.4vw 3vw;
}
::v-deep .van-cell__label {
  width: 60vw;
}
::v-deep .van-cell-group__title {
  background-color: #f8f8f8;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
